'use client';

import type { IUserSession } from '@repo/auth';
import { Error404Template } from '@repo/design-system';
import { SidebarInset, SidebarProvider } from '@repo/ui';
import { useTranslations } from 'next-intl';
import { DashboardSidebar } from '../_sidebar';
import { DashboardLayoutContent } from '../dashboard-layout-content';

interface IDashboard404PageProps {
  session: IUserSession | null;
}

export function Dashboard404Page({ session }: IDashboard404PageProps): React.ReactNode {
  const t = useTranslations('errors.notFound');
  return (
    <SidebarProvider
      style={
        {
          '--sidebar-width': 'calc(var(--spacing) * 72)',
          '--header-height': 'calc(var(--spacing) * 12)',
        } as React.CSSProperties
      }
    >
      <DashboardSidebar initialSession={session} />
      <SidebarInset>
        <DashboardLayoutContent>
          <Error404Template
            homeHref="/my"
            eyebrow={t('eyebrow')}
            title={t('title')}
            body={t('body')}
            ctaHome={t('ctaHome')}
          />
        </DashboardLayoutContent>
      </SidebarInset>
    </SidebarProvider>
  );
}
